<template>
  <div>
    <label for="text">
      Insurance Name
      <span class="star">*</span>
    </label>
    <el-select
      v-model="payor.payor"
      filterable
      remote
      reserve-keyword
      clearable
      placeholder="Enter Insurance Name"
      :remote-method="getAutoCompletePayorsData"
      @clear="clearData"
      @change="handleSelect"
      :loading="payorsLoading"
    >
      <el-option
        v-for="(item, index) in getAllPayorsIncludeCurrentPayor || []"
        :key="index"
        :label="item.name"
        :value="item.name"
      ></el-option>
    </el-select>
    <p class="error" v-if="validataionErrors && validataionErrors[getErrorKey]">
      {{ validataionErrors[getErrorKey] }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "payorData",
    "validataionErrors",
    "insuranceType",
    "clearPayor",
    "billTo",
  ],
  data() {
    return {
      payorsLoading: false,
      payor: "",
      includeCurrentPayor: true,
    };
  },
  computed: {
    ...mapGetters("payors", ["getAllPayors"]),
    getAllPayorsIncludeCurrentPayor() {
      return this.includeCurrentPayor
        ? [this.payorData]
        : this.getAllPayors?.data || [];
    },
    getErrorKey() {
      return `insurance.${this.insuranceType}.payor`;
    },
  },
  mounted() {
    this.payor = this.payorData;
  },
  methods: {
    async getAutoCompletePayorsData(queryString) {
      this.includeCurrentPayor = false;
      this.payorsLoading = true;
      if (queryString?.length > 1) {
        await this.$store.dispatch("payors/fetchAllPayors", {
          search_string: queryString,
          page: 1,
          limit: 10,
        });
      }
      this.payorsLoading = false;
    },
    clearData() {
      this.payor.payor = "";
      this.payor.insurance_carrier_code = "";
      this.payor.policy_id = "";
    },
    handleSelect(data) {
      const selectedPayor = this.getAllPayorsIncludeCurrentPayor.find(
        (item) => item.name === data
      );
      this.$emit("payorSelect", selectedPayor);
    },
    // setSelfPay() {
    //   const selfPayMap = {
    //     PATIENT: "Self Pay",
    //     CLIENT: "Client Bill",
    //     LABCORP: "Send out",
    //   };
    //   if (selfPayMap[this.billTo]) {
    //     this.payor.payor = selfPayMap[this.billTo];
    //     this.$emit("payorSelect", {
    //       name: selfPayMap[this.billTo],
    //       payor_electronic_id: selfPayMap[this.billTo],
    //     });
    //   }
    // },
  },
  watch: {
    clearPayor: {
      immediate: true,
      deep: true,
      handler: function () {
        if (this.clearPayor) {
          this.payor.payor = "";
          this.payor.insurance_carrier_code = "";
          this.payor.policy_id = "";
        }
        this.payor = this.payorData;
        // if (
        //   this.billTo == "PATIENT" ||
        //   this.billTo == "CLIENT" ||
        //   this.billTo == "LABCORP"
        // ) {
        //   this.setSelfPay();
        // } else {
        //   this.payor = this.payorData;
        // }
      },
    },
    payorData: {
      immediate: true,
      handler(newData) {
        this.payor = { ...newData };
      },
    },
    billTo: {
      immediate: true,
      deep: true,
      handler() {
        if (this.billTo === "INSURANCE") {
          this.payor = this.payorData;
        }
        //  else if (["PATIENT", "CLIENT", "LABCORP"].includes(this.billTo)) {
        //   this.setSelfPay();
        // }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  margin-top: 2px !important;
  color: #c14e4e;
  font-size: 14px;
  min-height: 30px;
}
</style>
